import { Response } from '../types';

import { dsmOpsAxios } from '.';

type UploadFirmwareData = {
  firmwareVersion: string;
  files: File[];
};

export type GetFirmwaresResponse = {
  firmwareVersion: string;
  createdAt: string;
  updatedAt: string;
  files: Array<{
    id: string;
    name: string;
    hardwareVersion: string;
    firmwareGroupId: string;
    createdAt: string;
    updatedAt: string;
  }>;
};

type DeleteFirmwareParams = {
  firmwareVersion: string;
  fileName: string;
};

// ── DasLoop ──────────────────────────────────────────────────────────────────

export const uploadFirmwares = (data: UploadFirmwareData) => {
  const formData = new FormData();
  data.files.forEach((f) => {
    formData.append('files', f);
  });
  return dsmOpsAxios.post(
    `/v1/dasloop-protocol/firmware-files/${data.firmwareVersion}`,
    formData,
  );
};

export const getFirmwares = () => {
  return dsmOpsAxios.get<Response<GetFirmwaresResponse[]>>(
    `/v1/dasloop-protocol/firmware-files`,
  );
};

export const deleteFirmware = (params: DeleteFirmwareParams) => {
  return dsmOpsAxios.delete<Response<GetFirmwaresResponse[]>>(
    `/v1/dasloop-protocol/firmware-files/${params.firmwareVersion}?fileName=${params.fileName}`,
  );
};

// ── DasSensesH ───────────────────────────────────────────────────────────────

export const uploadDassensesFirmwares = (data: UploadFirmwareData) => {
  const formData = new FormData();
  data.files.forEach((f) => {
    formData.append('files', f);
  });
  return dsmOpsAxios.post(
    `/v1/dassenses-protocol/firmware-files/${data.firmwareVersion}`,
    formData,
  );
};

export const getDassensesFirmwares = () => {
  return dsmOpsAxios.get<Response<GetFirmwaresResponse[]>>(
    `/v1/dassenses-protocol/firmware-files`,
  );
};

export const deleteDassensesFirmware = (params: DeleteFirmwareParams) => {
  return dsmOpsAxios.delete<Response<GetFirmwaresResponse[]>>(
    `/v1/dassenses-protocol/firmware-files/${params.firmwareVersion}?fileName=${params.fileName}`,
  );
};
